import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconVertexGcp = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M6 3C5.58579 3 5.25 3.33579 5.25 3.75V5.45C5.25 5.86421 5.58579 6.2 6 6.2C6.41421 6.2 6.75 5.86421 6.75 5.45V3.75C6.75 3.33579 6.41421 3 6 3Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M18.75 3.75C18.75 4.16421 18.4142 4.5 18 4.5C17.5858 4.5 17.25 4.16421 17.25 3.75C17.25 3.33579 17.5858 3 18 3C18.4142 3 18.75 3.33579 18.75 3.75Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M17.25 6.25C17.25 5.83579 17.5858 5.5 18 5.5C18.4142 5.5 18.75 5.83579 18.75 6.25V7.95C18.75 8.36421 18.4142 8.7 18 8.7C17.5858 8.7 17.25 8.36421 17.25 7.95V6.25Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M18 11.2C18.4142 11.2 18.75 10.8642 18.75 10.45C18.75 10.0357 18.4142 9.69995 18 9.69995C17.5858 9.69995 17.25 10.0357 17.25 10.45C17.25 10.8642 17.5858 11.2 18 11.2Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M18.75 12.95C18.75 13.3642 18.4142 13.7 18 13.7C17.5858 13.7 17.25 13.3642 17.25 12.95C17.25 12.5357 17.5858 12.2 18 12.2C18.4142 12.2 18.75 12.5357 18.75 12.95Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M15 6C15.4142 6 15.75 5.66421 15.75 5.25C15.75 4.83579 15.4142 4.5 15 4.5C14.5858 4.5 14.25 4.83579 14.25 5.25C14.25 5.66421 14.5858 6 15 6Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M14.25 7.75C14.25 7.33579 14.5858 7 15 7C15.4142 7 15.75 7.33579 15.75 7.75V9.45C15.75 9.86421 15.4142 10.2 15 10.2C14.5858 10.2 14.25 9.86421 14.25 9.45V7.75Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M15 12.7C15.4142 12.7 15.75 12.3642 15.75 11.95C15.75 11.5357 15.4142 11.2 15 11.2C14.5858 11.2 14.25 11.5357 14.25 11.95C14.25 12.3642 14.5858 12.7 15 12.7Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M15.75 14.45C15.75 14.8642 15.4142 15.2 15 15.2C14.5858 15.2 14.25 14.8642 14.25 14.45C14.25 14.0357 14.5858 13.7 15 13.7C15.4142 13.7 15.75 14.0357 15.75 14.45Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12 7.5C12.4142 7.5 12.75 7.16421 12.75 6.75C12.75 6.33579 12.4142 6 12 6C11.5858 6 11.25 6.33579 11.25 6.75C11.25 7.16421 11.5858 7.5 12 7.5Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.75 9.25C12.75 9.66421 12.4142 10 12 10C11.5858 10 11.25 9.66421 11.25 9.25C11.25 8.83579 11.5858 8.5 12 8.5C12.4142 8.5 12.75 8.83579 12.75 9.25Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12 11C11.5858 11 11.25 11.3358 11.25 11.75V13.45C11.25 13.8642 11.5858 14.2 12 14.2C12.4142 14.2 12.75 13.8642 12.75 13.45V11.75C12.75 11.3358 12.4142 11 12 11Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.75 15.95C12.75 16.3642 12.4142 16.7 12 16.7C11.5858 16.7 11.25 16.3642 11.25 15.95C11.25 15.5357 11.5858 15.2 12 15.2C12.4142 15.2 12.75 15.5357 12.75 15.95Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9 6C9.41421 6 9.75 5.66421 9.75 5.25C9.75 4.83579 9.41421 4.5 9 4.5C8.58579 4.5 8.25 4.83579 8.25 5.25C8.25 5.66421 8.58579 6 9 6Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9.75 7.75C9.75 8.16421 9.41421 8.5 9 8.5C8.58579 8.5 8.25 8.16421 8.25 7.75C8.25 7.33579 8.58579 7 9 7C9.41421 7 9.75 7.33579 9.75 7.75Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9 9.5C8.58579 9.5 8.25 9.83579 8.25 10.25V11.95C8.25 12.3642 8.58579 12.7 9 12.7C9.41421 12.7 9.75 12.3642 9.75 11.95V10.25C9.75 9.83579 9.41421 9.5 9 9.5Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9.75 14.45C9.75 14.8642 9.41421 15.2 9 15.2C8.58579 15.2 8.25 14.8642 8.25 14.45C8.25 14.0357 8.58579 13.7 9 13.7C9.41421 13.7 9.75 14.0357 9.75 14.45Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M6.75 7.94995C6.75 8.36416 6.41421 8.69995 6 8.69995C5.58579 8.69995 5.25 8.36416 5.25 7.94995C5.25 7.53574 5.58579 7.19995 6 7.19995C6.41421 7.19995 6.75 7.53574 6.75 7.94995Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M6 11.2C6.41421 11.2 6.75 10.8642 6.75 10.45C6.75 10.0357 6.41421 9.69995 6 9.69995C5.58579 9.69995 5.25 10.0357 5.25 10.45C5.25 10.8642 5.58579 11.2 6 11.2Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M6.75 12.95C6.75 13.3642 6.41421 13.7 6 13.7C5.58579 13.7 5.25 13.3642 5.25 12.95C5.25 12.5357 5.58579 12.2 6 12.2C6.41421 12.2 6.75 12.5357 6.75 12.95Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M9.69174 19.8968C9.72828 19.9181 9.75 19.9577 9.75 20V20C9.75 21.2426 10.7574 22.25 12 22.25C13.2426 22.25 14.25 21.2426 14.25 20V20C14.25 19.9577 14.2717 19.9181 14.3083 19.8968L19.8779 16.6478C20.2357 16.4391 20.3565 15.9799 20.1478 15.6221C19.9391 15.2643 19.4799 15.1435 19.1221 15.3522L13.8362 18.4356C13.7535 18.4839 13.6487 18.4659 13.5805 18.3986C13.1742 17.9976 12.616 17.75 12 17.75C11.384 17.75 10.8258 17.9976 10.4195 18.3986C10.3513 18.4659 10.2465 18.4839 10.1638 18.4356L4.8779 15.3522C4.52011 15.1435 4.06088 15.2643 3.85217 15.6221C3.64346 15.9799 3.76431 16.4391 4.1221 16.6478L9.69174 19.8968ZM11.25 20C11.25 19.5858 11.5858 19.25 12 19.25C12.4142 19.25 12.75 19.5858 12.75 20C12.75 20.4142 12.4142 20.75 12 20.75C11.5858 20.75 11.25 20.4142 11.25 20Z",
			fill: "currentColor"
		})
	]
});
export { SvgIconVertexGcp as ReactComponent };
